/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_About_MarkInputs */

const en_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Mark`)
};

const es_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Mark`)
};

const de_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Mark`)
};

const zh_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 Mark`)
};

const ar_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عن Mark`)
};

const fr_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de Mark`)
};

const vi_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về Mark`)
};

const sw_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuhusu Mark`)
};

const th_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ Mark`)
};

const bs_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku`)
};

const ja_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markについて`)
};

const ko_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark 소개`)
};

const pt_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Mark`)
};

const it_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi è Mark`)
};

const sv_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark`)
};

const nl_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over Mark`)
};

const da_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark`)
};

const nb_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark`)
};

const fi_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoja Markista`)
};

const pl_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku`)
};

const ru_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О тренере Mark`)
};

const tr_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Hakkında`)
};

const hi_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark के बारे में`)
};

const id_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Mark`)
};

const ms_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perihal Mark`)
};

const cs_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Markovi`)
};

const el_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σχετικά με τον Mark`)
};

const he_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`על Mark`)
};

const af_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oor Mark`)
};

const hu_nav_about_mark = /** @type {(inputs: Nav_About_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markról`)
};

/**
* | output |
* | --- |
* | "About Mark" |
*
* @param {Nav_About_MarkInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_about_mark = /** @type {((inputs?: Nav_About_MarkInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_About_MarkInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_about_mark(inputs)
	if (locale === "de") return de_nav_about_mark(inputs)
	if (locale === "zh") return zh_nav_about_mark(inputs)
	if (locale === "ar") return ar_nav_about_mark(inputs)
	if (locale === "fr") return fr_nav_about_mark(inputs)
	if (locale === "vi") return vi_nav_about_mark(inputs)
	if (locale === "sw") return sw_nav_about_mark(inputs)
	if (locale === "th") return th_nav_about_mark(inputs)
	if (locale === "bs") return bs_nav_about_mark(inputs)
	if (locale === "ja") return ja_nav_about_mark(inputs)
	if (locale === "ko") return ko_nav_about_mark(inputs)
	if (locale === "pt") return pt_nav_about_mark(inputs)
	if (locale === "it") return it_nav_about_mark(inputs)
	if (locale === "sv") return sv_nav_about_mark(inputs)
	if (locale === "nl") return nl_nav_about_mark(inputs)
	if (locale === "da") return da_nav_about_mark(inputs)
	if (locale === "nb") return nb_nav_about_mark(inputs)
	if (locale === "fi") return fi_nav_about_mark(inputs)
	if (locale === "pl") return pl_nav_about_mark(inputs)
	if (locale === "ru") return ru_nav_about_mark(inputs)
	if (locale === "tr") return tr_nav_about_mark(inputs)
	if (locale === "hi") return hi_nav_about_mark(inputs)
	if (locale === "id") return id_nav_about_mark(inputs)
	if (locale === "ms") return ms_nav_about_mark(inputs)
	if (locale === "cs") return cs_nav_about_mark(inputs)
	if (locale === "el") return el_nav_about_mark(inputs)
	if (locale === "he") return he_nav_about_mark(inputs)
	if (locale === "af") return af_nav_about_mark(inputs)
	if (locale === "hu") return hu_nav_about_mark(inputs)
	return en_nav_about_mark(inputs)
});